export default {
    name: 'register',
    title: 'Registro',
    type: 'document',
    fields: [
        {
            name: 'label',
            title: 'Nome',
            type: 'string'
        }, 
        {
            name: 'registerName',
            title: 'NomeRegistro',
            type: 'string'
        }, 
        {
            name: 'checkResetDays',
            title: 'Reset Giorni Controlli',
            type: 'number'
        }, 
                {
            name: 'notInMaintenance',
            title: 'Non In Manutenzione',
            type: 'boolean'
        }, 
        {
            name: 'site',
            title: 'Site',
            type: 'reference',
            to: [
                {
                    type: 'site'
                }
            ]
        }, {
            name: 'template',
            title: 'Modello',
            type: 'reference',
            to: [
                {
                    type: 'registerTemplates'
                }
            ]
        },   
        {
            name: 'registerFields',
            title: 'CampiRegistro',
            type: 'array',
            of: [
                {   
                  type: 'deviceField',
                }
            ],
        },
        {
            name: 'registerNonConformities',
            title: 'NonConformitaRegistro',
            type: 'array',
            of: [
                {
                    type: 'deviceNonConformity'
                }
            ],
        },
        {
            name: 'devices',
            title: 'Presidi',
            type: 'array',
            of: [
                {   
                  type: 'device',
                }
            ],
        }, 
        {
            name: 'worksheetNotes',
            title: 'NoteFoglioDiLavoro',
            type: 'array',
            of: [
                {   
                  type: 'worksheetNote',
                }
            ],
        },
        {
            name: 'postedBy',
            title: 'PostatoDa',
            type: 'array',
            of: [{ type: 'postedBy' }],

          }, 
        {
            name: 'status',
            title: 'Status',
            type: 'string',
          },    
    ]
}